import React from 'react';
import { Megaphone, Share2, Wind } from 'lucide-react';

const TopRibbon = ({ onShareClick, onBreathClick }) => {
  return (
    <div className="w-full bg-emerald-50/70 border-b border-emerald-100 text-emerald-900 text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2 px-4 py-2">
        <div className="flex items-center gap-2">
          <Megaphone className="w-4 h-4 text-emerald-700" />
          <span>Welcome to <span className="font-semibold">winwithmeditation.com</span> — Meditations &amp; Affirmations in English &amp; हिंदी</span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onShareClick} className="inline-flex items-center gap-1.5 rounded-full bg-white border border-emerald-200 px-3 py-1 hover:bg-emerald-100 transition-colors text-emerald-800">
            <Share2 className="w-3.5 h-3.5" /> Share Website
          </button>
          <button onClick={onBreathClick} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-700 text-white px-3 py-1 hover:bg-emerald-800 transition-colors">
            <Wind className="w-3.5 h-3.5" /> 2-Min Guided Breath
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopRibbon;
